export default __webpack_public_path__ + "static/media/966.84304e8c.png";